import { Cell } from './Cell'

export class Island {
  constructor(
    public cells: Cell[] = [],
    public coastline: Cell[] = [],
  ) {}
}
